"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("./styles");
var redux_1 = require("redux");
var react_redux_1 = require("react-redux");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
var MaterialWrapper_1 = __importDefault(require("../../ItemApp/MaterialWrapper"));
var FirstSection_1 = __importDefault(require("./FirstSection"));
var WhyUs_1 = __importDefault(require("./WhyUs"));
var Products_1 = __importDefault(require("./Products"));
var CTAForm_1 = __importDefault(require("./CTAForm"));
var EditorSection_1 = __importDefault(require("./EditorSection"));
var ExamplesSection_1 = __importDefault(require("./ExamplesSection"));
var PrintTechnology_1 = __importDefault(require("./PrintTechnology"));
var Payments_1 = __importDefault(require("./Payments"));
var Delivery_1 = __importDefault(require("./Delivery"));
var Trusted_1 = __importDefault(require("./Trusted"));
var Reviews_1 = __importDefault(require("./Reviews"));
var WhatElsePrint_1 = __importDefault(require("./WhatElsePrint"));
var UniqProducts_1 = __importDefault(require("./UniqProducts"));
var product_slice_1 = __importStar(require("./product-slice"));
var axios_1 = __importDefault(require("axios"));
var constants_1 = __importDefault(require("./constants"));
var reducer = (0, redux_1.combineReducers)({
    product: product_slice_1.default,
});
var Landing = function (props) {
    var content = props.content;
    var initialState = {
        product: props.state.content,
    };
    var store = (0, redux_1.createStore)(reducer, initialState, (0, redux_1.applyMiddleware)(redux_thunk_1.default));
    if (content.axiosLink)
        (0, react_1.useEffect)(function () {
            (0, axios_1.default)(content.axiosLink)
                .then(function (_a) {
                var data = _a.data;
                store.dispatch((0, product_slice_1.setState)(data));
            })
                .catch(console.error);
        }, []);
    return (react_1.default.createElement(react_redux_1.Provider, { store: store },
        react_1.default.createElement(MaterialWrapper_1.default, { materialUI: props.materialUI },
            react_1.default.createElement(styles_1.OverflowWrapper, null,
                react_1.default.createElement("div", { className: props.className },
                    react_1.default.createElement(FirstSection_1.default, { bgImage: content.FirstSectionBgImage, productLink: content.productLink, title: content.firstSectionTitle, text: content.firstSectionText, imageStyle: content.bgimageStyle }),
                    react_1.default.createElement(WhyUs_1.default, null),
                    react_1.default.createElement(Products_1.default, { products: content.products, title: content.productsTitle, authToken: props.state.authenticityToken, siteKey: props.state.siteKey }),
                    react_1.default.createElement(CTAForm_1.default, { className: 'service-cta-form', title: constants_1.default.CTAtitle1, authToken: props.state.authenticityToken, siteKey: props.state.siteKey }),
                    content.axiosLink && react_1.default.createElement(EditorSection_1.default, null),
                    react_1.default.createElement(ExamplesSection_1.default, null),
                    react_1.default.createElement(PrintTechnology_1.default, null),
                    react_1.default.createElement(CTAForm_1.default, { title: constants_1.default.CTAtitle2, authToken: props.state.authenticityToken, siteKey: props.state.siteKey }),
                    react_1.default.createElement(Payments_1.default, null),
                    react_1.default.createElement(Delivery_1.default, null),
                    react_1.default.createElement(Trusted_1.default, null),
                    react_1.default.createElement(Reviews_1.default, null),
                    react_1.default.createElement(WhatElsePrint_1.default, null),
                    react_1.default.createElement(CTAForm_1.default, { title: constants_1.default.CTAtitle3, green: true, authToken: props.state.authenticityToken, siteKey: props.state.siteKey }),
                    react_1.default.createElement(UniqProducts_1.default, { productNamePlural: content.productNamePlural, seoText: content.seoText }))))));
};
var SLanding = (0, styled_components_1.default)(Landing)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0px 40px;\n\n    h1,\n    h3,\n    h5 {\n        margin: 0;\n    }\n\n    ul {\n        padding: 0;\n        margin: 0;\n    }\n\n    p {\n        margin: 0;\n    }\n\n    a {\n        text-decoration: none;\n    }\n\n    @media (max-width: 480px) {\n        margin: 0px 20px;\n    }\n"], ["\n    margin: 0px 40px;\n\n    h1,\n    h3,\n    h5 {\n        margin: 0;\n    }\n\n    ul {\n        padding: 0;\n        margin: 0;\n    }\n\n    p {\n        margin: 0;\n    }\n\n    a {\n        text-decoration: none;\n    }\n\n    @media (max-width: 480px) {\n        margin: 0px 20px;\n    }\n"])));
exports.default = SLanding;
var templateObject_1;
